<template>
  <li class="comment-item">
    <img :src="newItemData.avatar"
         class="user-icon" alt="">
    <div class="comment-wrap">
      <div class="name-star">
        <span class="diandiandian-single user-name">{{ itemData.nickName }}</span>
        <div class="star-wrap">
          <img class="star-img"
               v-for="item in newItemData.starArr"
               :src="`${starArr[item]}`" alt="" :key="item.avatar">
        </div>
      </div>
      <div class="learn-info">
        <!--        <div class="days">已经学习{{}}天</div>-->
        <!--        <span class="line"></span>-->
        <div class="diandiandian-single school">{{ itemData.title }}</div>
        <div class="times">{{ itemData.date }}</div>
      </div>
      <div class="label-wrap">
        <span class="label" v-for="item in itemData.tags" :key="item">{{ item }}</span>
      </div>
      <p class="comment-content">{{ itemData.content }}！</p>
    </div>
  </li>
</template>

<script>
export default {
  name: 'CommentItem',
  props: {
    itemData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      starArr: [require('./images/no_star.png'), require('./images/commentstar.png')]
    };
  },
  computed: {
    newItemData() {
      let { grade } = this.itemData;
      let arr = [1, 1, 1, 1, 1];
      arr = arr.map((item, index) => {
        if (index >= grade) {
          return 0;
        } else {
          return 1;
        }
      });
      return { ...this.itemData, starArr: arr };
    }
  },
  watch: {
    itemData: {
      handler(n) {

        // console.log(n);
        // let
        // n.map((item, index) => {
        //   let arr = [1, 1, 1, 1, 1];
        //   arr.map((item2, index2) => {
        //     if (index2 > item.grade) {
        //       return 0;
        //     } else {
        //       return 1;
        //     }
        //   });
        //   console.log(arr);
        //   item.starArr = arr;
        //   return item
        // });
      },
      immediate: true
    }
  }
};
</script>

<style scoped lang="stylus">
.comment-item {
  padding 10px 20px 20px 20px
  display: flex;

  .user-icon {
    width: 40px
    height: 40px
    border-radius 100%
    margin-top: 3px
  }

  .comment-wrap {
    flex 1
    padding-left: 15px

    .name-star {
      display: flex;
      justify-content space-between
      align-items center
      margin-bottom: 5px

      .user-name {
        color #41414D
        font-size: 16px
        font-weight: bold;
        width: 160px
        height: 100%
        padding-top: 2px
      }

      .star-img {
        width: 21px
        height: 21px
      }
    }

    .learn-info {
      color #6D6D80
      font-size: 13px
      display: flex;
      align-items center
      margin: 0px 0 10px 0;

      .line {
        width: 1px;
        height: 12px;
        background: rgba(230, 230, 237, 1);
        border-radius: 1px;
        margin 0 6px
      }

      .school {
        margin-right auto
        width: 200px
        padding-top: 2px
      }
    }

    .label-wrap {
      /*margin-top: 6px*/
      /*height auto*/
      display: flex;
      flex-wrap wrap

      .label {
        padding 4px
        font-size: 12px
        color #FF5F2E
        background-color rgba(255, 95, 46, 0.1);
        border-radius: 4px;
        margin-right: 3px
        margin-top: 4px
      }
    }

    .comment-content {
      margin-top: 8px
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(65, 65, 77, 1);
      line-height: 24px;
    }
  }
}

</style>
